// extracted by mini-css-extract-plugin
export default {"inputContainer":"CustomInput_inputContainer__gLJ+U","label":"CustomInput_label__h73BU","selectContainer":"CustomInput_selectContainer__u1atC"};